<template>
  <div class="el-section">
    <invite-alert
      v-if="alert.show"
      :alert="alert"
      class="eu-no-padding"
      @cancel="alert.show = false"
    />

    <div
      v-if="loadingDetail"
      class="eu-pa_6 eu-align_center"
    >
      <emd-loader :type="'_invert'" />
    </div>

    <emd-card
      v-else
      class="_highlight_header _footer_end"
    >
      <emd-card-header>
        <emd-text
          size="section"
          tag="h2"
        >
          {{ $t('team.user_info') }}
        </emd-text>
        <template #actions>
          <div
            v-if="showActionsButton"
            id="jsDropdown"
            class="emd-dropdown _position_right"
          >
            <div class="emd-dropdown__trigger">
              <emd-button
                color="primary"
                size="small"
                @click="toogleDropdown"
                >{{ $t('team.actions.title') }}
              </emd-button>
            </div>
            <div
              class="emd-dropdown__content"
              :class="{ _active: showActionsDropdown }"
            >
              <nav class="emd-nav-list _direction_column _hoverble">
                <ul>
                  <li
                    v-if="canEditEnable"
                    class="emd-nav-list__item eu-no-margin"
                    @click="toggleEdit = true"
                  >
                    <emd-button
                      class="eu-pa_3"
                      color="primary"
                      type="link"
                    >
                      <span class="uil uil-pen" />
                      {{ $t('team.actions.edit') }}
                    </emd-button>
                  </li>
                  <li
                    v-if="canRemoveEnable"
                    class="emd-nav-list__item eu-no-margin"
                    @click="modalOpenned = true"
                  >
                    <emd-button
                      class="eu-pa_3"
                      color="danger"
                      type="link"
                    >
                      <span class="uil uil-times-circle" />
                      {{ $t('team.actions.remove-permission') }}
                    </emd-button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </template>
      </emd-card-header>

      <emd-card-content customClass="eu-pa_3">
        <user-personal-data :user="user" />

        <user-form-update
          :editing="toggleEdit"
          :loading="loadingEdit"
          :user="user"
          @cancelEditing="toggleEdit = false"
          @getUser="getUser"
          @setAlert="setAlert"
          @resetAlert="resetAlert"
        />
      </emd-card-content>
    </emd-card>

    <modal-password
      v-if="modalOpenned"
      :callback="removePermission"
      @cancel="modalOpenned = false"
    ></modal-password>
  </div>
</template>

<script>
import {
  EmdCard,
  EmdCardContent,
  EmdCardHeader,
  EmdLoader,
  EmdButton,
  EmdText
} from 'emerald-vue/src/components'
import { formatErrorMessage } from '@/support/formatErrorMessage'
import ModalPassword from '@/components/project/globals/ModalPassword.vue'
import { mapActions, mapGetters } from 'vuex'
import { isStaffType } from '@/enums/merchant-type.enum'
import { usersEditEnabled } from '@/actions-permission/users.permissions.js'
import UsersManager from '@/views/Team/Users/user.manager.js'
import InviteAlert from '@/views/Team/Invites/components/InviteAlert.vue'
import UserPersonalData from './components/UserPersonalData.vue'
import UserFormUpdate from './components/UserFormUpdate.vue'

export default {
  name: 'UsersDetail',
  components: {
    UserPersonalData,
    UserFormUpdate,
    EmdLoader,
    EmdText,
    ModalPassword,
    InviteAlert,
    EmdCard,
    EmdButton,
    EmdCardHeader,
    EmdCardContent
  },
  data () {
    return {
      user: {
        account: {
          role: {}
        }
      },
      loadingDetail: true,
      loadingEdit: true,
      toggleEdit: false,
      showActionsDropdown: false,
      modalOpenned: false,
      alert: {
        show: false,
        isError: false,
        messages: []
      }
    }
  },
  watch: {
    toggleEdit () {
      this.closeDropdown()
    },
    modalOpenned () {
      this.closeDropdown()
    }
  },
  computed: {
    ...mapGetters(['accountId', 'profile', 'permissionIsEnabled']),
    userId () {
      return this.$route.params.id
    },
    canEditEnable () {
      return usersEditEnabled(this.permissionIsEnabled)
    },
    canRemoveEnable () {
      return usersEditEnabled(this.permissionIsEnabled)
    },
    showActionsButton () {
      const isStaff = isStaffType(this.user.merchant.type.key)
      const actionEnable = this.canEditEnable || this.canRemoveEnable
      const notLoggedUser = this.profile.user.email !== this.user.email
      return isStaff && actionEnable && notLoggedUser
    }
  },
  created () {
    this.GET_ROLES()
    this.getUser()
    document.addEventListener('mouseup', this.handleMouseup, { passive: true })
  },
  beforeDestroy () {
    document.removeEventListener('mouseup', this.handleMouseup)
  },
  methods: {
    ...mapActions(['GET_USER_DETAIL', 'REMOVE_PERMISSION', 'GET_ROLES']),
    handleMouseup (e) {
      const actionsDropdown = document.getElementById('jsDropdown')
      if (actionsDropdown && !actionsDropdown.contains(e.target)) {
        this.showActionsDropdown = false
      }
    },
    toogleDropdown () {
      this.showActionsDropdown = !this.showActionsDropdown
    },
    closeDropdown () {
      if (this.modalOpenned || this.toggleEdit) {
        this.$nextTick().then(() => {
          this.showActionsDropdown = false
        })
      }
    },
    async getUser () {
      this.loadingDetail = true
      this.toggleEdit = false
      try {
        const res = await this.GET_USER_DETAIL({ userId: this.userId })
        this.user = new UsersManager(this.accountId, [res]).getOne()
      } finally {
        this.loadingDetail = false
      }
    },
    closeModal () {
      this.toggleEdit = false
    },
    setAlert (data) {
      this.alert = data
    },
    resetAlert () {
      this.alert = {
        show: false,
        isError: false,
        messages: []
      }
    },
    removePermission (password) {
      this.showActionsDropdown = false
      const params = {
        userId: this.userId,
        body: { password }
      }
      const msgErrorInternal = this.$t('team.error-internal')
      return this.REMOVE_PERMISSION(params)
        .then(() => {
          this.$router.push({ name: 'users' }).catch(err => err)
        })
        .catch(err => {
          this.alert = {
            show: true,
            isError: true,
            messages: formatErrorMessage(err, msgErrorInternal)
          }
        })
    }
  }
}
</script>
